import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import URLConstants from 'constants/urlConstants';
import { receiveOptionsType } from '../../@types/receiveOptionsType';

type  receiveOptionsState = {
    isLoading: boolean;
    error: boolean;
    receiveOptions: receiveOptionsType[];
}

const initialState: receiveOptionsState = {
    isLoading: false,
    error: false,
    receiveOptions: [],
}

const slice = createSlice({
    name: 'receive',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET OUTBOUNT OPTIONS
        getReceiveOptionsSuccess(state, action) {
            state.isLoading = false;
            state.receiveOptions = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function getReceiveOptions() {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get(URLConstants.RECEIVE_OPTIONS_BASE_URL);
        dispatch(slice.actions.getReceiveOptionsSuccess(response.data.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }